import type { ProductImage } from '@/components/products/detail/types';
import settings from '@/constants/constants';

const unavailableProductImage = `${settings.productImageUrl}Image_Unavailable.png`;

// Internal scope can see real product image
const getProductImageUrl = (imageUrl?: string | null, productImages?: Pick<ProductImage, 'image_url'>[]): string => {
  const image = productImages?.length ? productImages[0].image_url : imageUrl && settings.productImageUrl + imageUrl;

  return image || unavailableProductImage;
};

export default getProductImageUrl;
